(function () {
  'use strict';

  function normalizeCookieHeading() {
    var heading = document.getElementById('shopify-pc__banner__body-title');
    if (!heading) return false;
    if (heading.tagName.toLowerCase() !== 'h2') return true;

    var text = document.createElement('p');
    Array.prototype.forEach.call(heading.attributes, function (attribute) {
      text.setAttribute(attribute.name, attribute.value);
    });

    while (heading.firstChild) text.appendChild(heading.firstChild);
    heading.parentNode.replaceChild(text, heading);
    return true;
  }

  if (normalizeCookieHeading()) return;

  var observer = new MutationObserver(function () {
    if (!normalizeCookieHeading()) return;
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 15000);
})();
